// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","label":"textOption_label__Y8_Jv","input":"textOption_input__IlTX3","inputNewDesignV2":"textOption_inputNewDesignV2__yIehi"};